import { observer } from 'mobx-react'
import React, { useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { createConnectionApi } from '../services/apiService'
import { useStores } from '../stores'
import { colors, fonts } from '../utils/theme'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import Routes from '../Routes'
import qs from 'query-string'

const APPTheme = createTheme({
  typography: { ...fonts.SP_LIGHT },
  palette: {
    success: { main: colors.SUCCESS_COLOR },
    error: { main: colors.ATTENTION_COLOR },
    warning: { main: colors.WARNING_COLOR },
    primary: { main: colors.PRIMARY_COLOR },
    secondary: { main: colors.SECONDARY_COLOR }
  },
  components: {
    MuiTextField: {},
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: colors.ATTENTION_COLOR,
          '&$error': { colors: colors.ATTENTION_COLOR }
        }
      }
    }
  }
})

const App = observer(() => {
  const { registerStore } = useStores()
  const [registrationDone, setRegistrationDone] = useState<boolean | null>(null)

  React.useEffect(() => {
    setTimeout(() => {
      const registerDevice = async () => {
        await createConnectionApi()

        // eslint-disable-next-line  no-restricted-globals
        const value = qs.parse(location.search)
        const connectedToken = value.token
        const partnerCode = value.partnerCode

        if (connectedToken) {
          setRegistrationDone(await registerStore.registerConnectedDevice(connectedToken))
        } else {
          setRegistrationDone(await registerStore.registerDevice(partnerCode))
        }
      }
      registerDevice()
    }, 500)
  }, [registerStore])

  return (
    <ThemeProvider theme={APPTheme}>
      {registrationDone === true && (
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      )}
      {registrationDone === false && (
        <span>{'Initialisation failed, please refresh browser'}</span>
      )}
      {registrationDone === null && (
        <span>{'Init...'}</span>
      )}
    </ThemeProvider>
  )
})

export default App
